import { twApi } from './../api';
import { BaseQueryParams, PaginateResponse } from './../../Global.model';

import { EldAssetId, EldConnectionInfo, EldDriver, SearchAssetIdsParams } from './eld.model';

/**
 * Api endpoints for eld related entity
 */
const eldApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getConnections: builder.query<PaginateResponse<EldConnectionInfo>, BaseQueryParams>({
      query: (searchParams) => {
        const queryParams = searchParams;
        return {
          url: 'eld/connections/search',
          method: 'POST',
          params: queryParams
        };
      },
      transformResponse: (response: { data: EldConnectionInfo[]; total: number }) => {
        return {
          content: response.data,
          total: response.total
        };
      },
      providesTags: (result) =>
        result?.content
          ? [
              ...result.content.map(({ id }) => ({ type: 'Connections' as const, id })),
              { type: 'Connections', id: 'CONNECTIONS_LIST' }
            ]
          : [{ type: 'Connections', id: 'CONNECTIONS_LIST' }]
    }),
    getAssetIds: builder.query<PaginateResponse<EldAssetId>, SearchAssetIdsParams>({
      query: (searchAssetIdsParams) => {
        const { params, connectionId } = searchAssetIdsParams;
        return {
          url: `eld/connections/${connectionId}/asset-ids`,
          method: 'GET',
          params
        };
      },
      transformResponse: (response: { data: EldAssetId[]; total: number }) => {
        return {
          content: response.data,
          total: response.total
        };
      },
      providesTags: (result) =>
        result?.content
          ? [
              ...result.content.map((asset) => ({ type: 'Assets' as const, asset })),
              { type: 'Assets', id: 'ASSETS_LIST' }
            ]
          : [{ type: 'Assets', id: 'ASSETS_LIST' }]
    }),
    getDriversByConnection: builder.query<PaginateResponse<EldDriver>, SearchAssetIdsParams>({
      query: (searchAssetIdsParams) => {
        const { connectionId } = searchAssetIdsParams;
        return {
          url: `eld/connections/${connectionId}/drivers`,
          method: 'GET'
        };
      },
      transformResponse: (response: { data: EldDriver[]; total: number }) => {
        return {
          content: response.data,
          total: response.total
        };
      },
      providesTags: (result) =>
        result?.content
          ? [
              ...result.content.map((asset) => ({ type: 'Assets' as const, asset })),
              { type: 'Assets', id: 'ASSETS_LIST' }
            ]
          : [{ type: 'Assets', id: 'ASSETS_LIST' }]
    })
  }),
  overrideExisting: false
});

export const { useGetConnectionsQuery, useGetAssetIdsQuery, useGetDriversByConnectionQuery } =
  eldApi;
